import React from 'react';

import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles';
import { TelemonitoringTags } from '@/models/CarePlanModel';
import {
  telemonitoringTagColorMapping,
  telemonitoringTagTranslationMapping,
} from '@/models/PatientSummaryModel.ts';
import { Tag } from '@/uiKit/atoms/Tag.tsx';
import { TagList } from '@/uiKit/atoms/TagList.tsx';

type PatientsTagsListProps = {
  telemonitoringTags: TelemonitoringTags[];
  className?: string;
};

export const PatientsTagsList: React.FC<PatientsTagsListProps> = ({
  className,
  telemonitoringTags,
}) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  if (!telemonitoringTags.length) {
    return null;
  }

  const tagsSet = new Set(telemonitoringTags);

  // The following rules are UI rules for displaying tags
  if (tagsSet.has('no_glycemia_data')) {
    if (tagsSet.has('expiring_soon')) {
      tagsSet.delete('expiring_soon');
    }
    if (tagsSet.has('expired_recently')) {
      tagsSet.delete('no_glycemia_data');
    } else if (tagsSet.has('expired')) {
      tagsSet.delete('no_glycemia_data');
    }
  }
  if (tagsSet.has('expired_recently')) {
    tagsSet.delete('expired');
  }

  return (
    <TagList className={cx(styles.container, className)}>
      {Array.from(tagsSet).map(tag => {
        return (
          <Tag
            key={tag}
            color={telemonitoringTagColorMapping(tag)}
            label={t(telemonitoringTagTranslationMapping(tag))}
          />
        );
      })}
    </TagList>
  );
};
const makeStyles = () => ({
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 24px; // MUI Chip height
    align-content: flex-start;
  `,
});
